// extracted by mini-css-extract-plugin
export var alt = "ParagraphSailDates-module--alt--e9941";
export var container = "ParagraphSailDates-module--container--3c841";
export var desktopOnly = "ParagraphSailDates-module--desktopOnly--c7c7a";
export var main = "ParagraphSailDates-module--main--19283";
export var mobileOnly = "ParagraphSailDates-module--mobileOnly--a53c4";
export var textLeft = "ParagraphSailDates-module--textLeft--02bb6";
export var visuallyHidden = "ParagraphSailDates-module--visuallyHidden--143f9";